<template>
    <iframe :src="src"
            class="border-0 flex-grow-1"
    ></iframe>
</template>

<script>
    export default {
        name: "ApplicationViewer",
        props: {
            src: {
                required: true,
                type: String
            }
        }
    }
</script>

<style scoped>

</style>
